import { Alert, Stack, Typography } from "@mui/material";
import { AccordionKeys } from "@shared";

import { LastAgreement } from "@/api";
import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { formatCaseNoteDateTime } from "@/pages/clients/client/components/tabs/notes-tab/CaseNotes.utils";
import { useTranslation } from "@/translations";

import { ClientAccordion } from "../client-accordion/ClientAccordion";

interface Props {
  lastAgreement: LastAgreement | null;
  defaultExpanded?: boolean;
}

export function ClientCurrentAgreementOverview({ lastAgreement, defaultExpanded = true }: Props) {
  const { t } = useTranslation();
  const { language } = useLanguageContext();

  return (
    <ClientAccordion
      title={t("clients.client.overview.currentAgreement")}
      defaultExpanded={defaultExpanded}
      accordionKey={AccordionKeys.client.currentAgreement}
    >
      {lastAgreement ? (
        <Stack px={1}>
          <Typography variant="body2" fontWeight={"bold"}>
            {formatCaseNoteDateTime(language, lastAgreement.noteDate, lastAgreement.noteTime, t("common.clock"))}
          </Typography>
          <Typography variant="body2" whiteSpace={"pre-wrap"}>
            {lastAgreement.agreement}
          </Typography>
        </Stack>
      ) : (
        <Alert severity={"error"} icon={false} sx={{ typography: "caption" }}>
          {t("common.noInformationAvailable")}
        </Alert>
      )}
    </ClientAccordion>
  );
}
